
//Valore di default di tutti i campi country dell'applicazione

import { EventTypeBulgari } from "./event-type-enum";

//TODO Per eventi particolari modificare le costanti

//*Per l'evento della Cina
// export const DEFAULT_COUNTRY_CODE = 'CN';
export const DEFAULT_COUNTRY_CODE = '';

//*Per l'evento della Cina
// export const DEFAULT_EVENT_TYPE = EventTypeBulgari.ChinaRHE;
// export const DEFAULT_EVENT_TYPE = ''
//*Per l'evento della Cambogia
// export const DEFAULT_EVENT_TYPE = EventTypeBulgari.CambodiaRHE;
//*Per l'evento del Giappone
// export const DEFAULT_EVENT_TYPE = EventTypeBulgari.RegionalEvent;
//*Per brand event
export const DEFAULT_EVENT_TYPE = EventTypeBulgari.BrandEvent;

//*Commentati tutti gli eventType per l'evento della Cina
//*Commentati tutti gli eventType tranne REEurope per l'evento della Cambogia
export const EVENT_TYPE_OPTIONS = [
  // {
  //   key: 'BrandEvent',
  //   value: EventTypeBulgari.BrandEvent,
  // },
  // {
  //   key: 'REEurope',
  //   value: EventTypeBulgari.REEurope,
  // },
  // {
  //   key: 'BPBrandEvent',
  //   value: EventTypeBulgari.BPBrandEvent,
  // },
  // {
  //   key: 'RUSBrandEvent',
  //   value: EventTypeBulgari.RUSBrandEvent,
  // },
  {
    key: 'RegionalEvent',
    value: EventTypeBulgari.RegionalEvent,
  },
  // {
  //   key: 'TrunkShow',
  //   value: EventTypeBulgari.TrunkShow,
  // },
]

export const DEFAULT_MAXIMUM_BASKET_CAPACITY = 6;

export enum bpAvailability {
  REEurope,
  RUSBrandEvent,
  BrandEvent
}

export enum clientSegmentType {
  RUBY,
  EMERALD2,
  TURQUOISE,
  EMERALD1,
  RUBELLITE,
  GOLD2,
  SAPPHIRE,
  GOLD1,
  SILVER,
  EXISTING_NOT_HE,
  PROSPECTS
}

export const DEFAULT_BP_AVAILABILITY = bpAvailability.REEurope;

export const bpAvailability_OPTIONS = [
  {
    key: 'REEurope',
    value: bpAvailability.REEurope,
  },
  // {
  //   key: 'RUSBrandEvent',
  //   value: bpAvailability.RUSBrandEvent,
  // },
  // {
  //   key: 'BrandEvent',
  //   value: bpAvailability.BrandEvent,
  // },
]

export const clientSegment_OPTIONS = [
  {
    key: 'EMERALD1',
    value: clientSegmentType.EMERALD1,
  },
  {
    key: 'EMERALD2',
    value: clientSegmentType.EMERALD2,
  },
  {
    key: 'EXISTING_NOT_HE',
    value: clientSegmentType.EXISTING_NOT_HE,
  },
  {
    key: 'GOLD1',
    value: clientSegmentType.GOLD1,
  },
  {
    key: 'GOLD2',
    value: clientSegmentType.GOLD2,
  },
  {
    key: 'PROSPECTS',
    value: clientSegmentType.PROSPECTS,
  },
  {
    key: 'RUBELLITE',
    value: clientSegmentType.RUBELLITE,
  },
  {
    key: 'RUBY',
    value: clientSegmentType.RUBY,
  },
  {
    key: 'SAPPHIRE',
    value: clientSegmentType.SAPPHIRE,
  },
  {
    key: 'SILVER',
    value: clientSegmentType.SILVER,
  },
  {
    key: 'TURQUOISE',
    value: clientSegmentType.TURQUOISE,
  },
]

